import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchFieldLicenses() {
    return new Promise((resolve, reject) => {
      API.licenses.getFieldLicenses(
        resp => {
          let licenses = resp.data;
          resolve(licenses);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  fetchFibercloudLicenses() {
    return new Promise((resolve, reject) => {
      API.licenses.getFibercloudLicenses(
        resp => {
          let licenses = resp.data;
          resolve(licenses);
        },
        error => {
          reject(error.response);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/licenses.js